module.exports = __webpack_public_path__ + "img/pr-4.2afe3ae1.png";